module.exports = __webpack_public_path__ + "static/media/MERL.86040a67.svg";